
















































import Vue from 'vue'
import PilotArmorCard from './_PLArmorCard.vue'
import PilotWeaponCard from './_PLWeaponCard.vue'
import PilotGearCard from './_PLGearCard.vue'
import { PilotArmor, PilotWeapon, PilotGear } from '@/class'

export default Vue.extend({
  name: 'cc-pilot-loadout',
  components: { PilotArmorCard, PilotWeaponCard, PilotGearCard },
  props: {
    pilot: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
    },
  },
  methods: {
    gear() {
      return this.pilot.Loadout.Gear
    },
    extendedGear() {
      if (this.pilot.has('reserve', 'extendedharness')) return this.pilot.Loadout.ExtendedGear
      return []
    },
    weapons() {
      return this.pilot.Loadout.Weapons
    },
    extendedWeapons() {
      if (this.pilot.has('reserve', 'extendedharness')) return this.pilot.Loadout.ExtendedWeapons
      return []
    },
    setArmor(a: PilotArmor | null) {
      this.$set(this.pilot.Loadout.Armor, 0, a)
      this.pilot.Heal()
    },
    setWeapon(w: PilotWeapon | null, idx: number) {
      this.$set(this.pilot.Loadout.Weapons, idx, w)
      this.pilot.Heal()
    },
    setGear(g: PilotGear | null, idx: number) {
      this.$set(this.pilot.Loadout.Gear, idx, g)
      this.pilot.Heal()
    },
  },
})
